'use client';

import { useEffect, useRef } from 'react';

/**
 * CSS `zoom` on <html> (see app/globals.css "Desktop Zoom") puts the page in a
 * scaled coordinate space: reads such as `clientX`/`getClientRects()` come back
 * in viewport px, but px WRITTEN into styles inside the tree are interpreted in
 * the scaled space. Consumers that position elements from viewport coordinates
 * must divide every written value by this factor to land exactly.
 */
export function useViewportZoom(): React.MutableRefObject<number> {
    const ref = useRef(1);

    useEffect(() => {
        const update = () => {
            const z = parseFloat(getComputedStyle(document.documentElement).zoom);
            ref.current = Number.isFinite(z) && z > 0 ? z : 1;
        };
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    return ref;
}
